import React from "react";
import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { Star } from "lucide-react";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ height: "100vh" }}
    >
      {/* Full Screen Video Background */}
      <video
        src="/hero-video.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full"
        style={{ objectFit: "cover", objectPosition: "center" }}
      />

      {/* Dark Overlay */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(0, 0, 0, 0.15)" }}
      />

      {/* Text Content - Video ke upar */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl space-y-6"
          >
            <p
              className="text-xs font-bold tracking-wider uppercase"
              style={{ color: "#7B7BFF" }}
            >
              
            </p>

            <h1
              className="text-5xl md:text-6xl font-black leading-tight"
              style={{ color: "#FFFFFF", fontFamily: "Inter, sans-serif" }}
            >
              Trusted Legal
              <br />
              Representation
              <br />
              Across India
            </h1>

            <p
              className="text-lg leading-relaxed"
              style={{ color: "rgba(255,255,255,0.85)" }}
            >
              NAMORISATYA LEGAL & ASSOCIATES offers expert legal counsel in civil, criminal
              and corporate matters before the Patna High Court, Supreme Court of India,Delhi High
              Court, Allahabad High Court, Jharkhand High Court and all District
              Courts.
            </p>

            {/* Buttons */}
            <div className="flex flex-wrap gap-4">
              <Button
                onClick={scrollToContact}
                className="text-base font-semibold px-8 py-6 transition-all duration-300 hover:opacity-90"
                style={{ backgroundColor: "#2B2BFF", color: "white" }}
              >
                Contact Us
              </Button>
              <Button
                onClick={scrollToContact}
                variant="outline"
                className="text-base font-semibold px-8 py-6 transition-all duration-300"
                style={{
                  borderColor: "white",
                  color: "white",
                  borderWidth: "2px",
                  backgroundColor: "transparent",
                }}
              >
                Book Consultation
              </Button>
            </div>

            {/* Star Ratings */}
            <div className="flex flex-wrap gap-8 pt-4">
              {[
                "Client Satisfaction",
                "Court Success Rate",
                "Trusted by Clients",
              ].map((label) => (
                <div key={label} className="space-y-2">
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-4 w-4"
                        fill="#2B2BFF"
                        stroke="#2B2BFF"
                      />
                    ))}
                  </div>
                  <p
                    className="text-xs font-semibold"
                    style={{ color: "rgba(255,255,255,0.9)" }}
                  >
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
